import { useState } from "react"
import { changeLineStatus } from "../../../api/requestAxios/RestrictedCall"
import { ToPersianNumber } from "../../../functions"
import GSPTable from "../../../shared/GSFTable"
import { enToPersianChar } from "../../activities"
import { LineStatus } from "../enum"
import CustomValuesHook from "../../../Hooks/customValuesHook"
import { ErrorToast, InfoToast } from "../../../shared"
import History from "./history"
import { DiableLine } from "../../../assets/images/svg/diableLine"
import { EnabelLine } from "../../../assets/images/svg/enabelLine"
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from '@material-ui/core/styles';
import { toast } from "react-toastify"




const TabelView = ({
    data,
    getData
}) => {

    const [showHistory, setShowHistory] = useState(false)
    const [historyItem, setHistoryItem] = useState('')
    const [loading, setLoading] = useState(false);


    // const [params, setParams] = CustomValuesHook({
    //     extention: "",
    //     lineStatus: ""
    // })

    const showDetails = (item) => {
        setShowHistory(true)
        setHistoryItem(item)
    }

    const changeStatuslineFn = async (obj) => {
        try {
            setLoading(true);
            let params = {
                extention: obj?.extention,
                lineStatus: obj?.lineStatus
            }
            const data = await changeLineStatus(params)
            setLoading(false);
            InfoToast(data?.data?.message)
            if (data?.data?.success) {
                getData()
            }

        }
        catch (err) {
            setLoading(false);
            ErrorToast(err)
        }
    };

    const changeStatusline = (item) => {
        let obj = {
            extention: item?.extention,
            lineStatus: item?.lineStatus === LineStatus.Available ? "WaitToActive" : "Available "
        }
        changeStatuslineFn(obj)
    }

    const rowComponent = ({ item }) => {
        return ToPersianNumber(item?.row)
    }
    const extenstionCompo = ({ item }) => {
        return item?.extention.startsWith('+98')? item?.extention?.replace('+98','0'):item?.extention
    }
    const statusComponent = ({ item }) => {
        if (item?.lineStatus === LineStatus.Available) return <span className="in-show">در حال نمایش</span>
        if (item?.lineStatus === LineStatus.WaitToActive) return <span className="waite-for-free"> در انتظار آزادسازی</span>
        if (item?.lineStatus === LineStatus.None) return <span className="waite-for-free"> هیچ کدام</span>
        if (item?.lineStatus === LineStatus.Reserved) return <span className="waite-for-free">رزرو شده</span>
        if (item?.lineStatus === LineStatus.InUse) return <span className="waite-for-free"> در  حال استفاده</span>
        if (item?.lineStatus === LineStatus.Parked) return <span className="waite-for-free"> معلق </span>
        if (item?.lineStatus === LineStatus.NotforSale) return <span className="waite-for-free"> غیر قابل فروش </span>


    }
    const CountCallComponent = ({ item }) => {
        return ToPersianNumber(item?.callCount)
    }
    const dateComponent = ({ item }) => {
        enToPersianChar(item?.lastAvailableDate)
    }
    const historytComponent = ({ item }) => {
        return <div onClick={() => showDetails(item)} className="view-details">مشاهده جزییات</div>
    }
    const changeStatusComponent = ({ item }) => {
        return (
            <>
                {item?.lineStatus === LineStatus.Available && <span title="غیر فعال کردن" className="block-icon" onClick={() => changeStatusline(item)}> <DiableLine /></span>}
                {item?.lineStatus === LineStatus.WaitToActive && <span title=" فعال کردن" className="block-icon" onClick={() => changeStatusline(item)}> <EnabelLine /></span>}
            </>
        )


    }



    const columns = [
        { title: 'ردیف', property: 'row', component: rowComponent, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'شماره خط', property: 'extention', component: extenstionCompo, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'وضیت خط', property: 'lineStatus', component: statusComponent, filterProperty: null, hasSort: false, hasFilter: false, display: true },
        { title: 'تعداد تماس دریافتی', property: 'callCount', filterProperty: null, component: CountCallComponent, hasSort: false, hasFilter: false, display: true },
        { title: 'تاریخ آزادسازی', property: 'lastAvailableDate', filterProperty: null, component: dateComponent, hasSort: false, hasFilter: false, display: true },
        { title: 'عملیات', property: '', filterProperty: null, component: changeStatusComponent, hasSort: false, hasFilter: false, display: true },
        { title: 'تاریخچه', property: '', filterProperty: null, component: historytComponent, hasSort: false, hasFilter: false, display: true },
    ]

    return (
        <div>
            <GSPTable
                columns={columns}
                apiCall={getData}
                hasSorting={false}
                dataList={data}
                hasFiltering={false}
                hasPaging={true}
                pageSize={50}
                enableScrolling={false}
                isStepScrolling={false}
                loading={loading}
            />
            {showHistory && <History setShowHistory={setShowHistory} showHistory={showHistory} item={historyItem} />}

        </div>
    )
}

export default TabelView